import { UserRole } from '../../../../../../../common/interfaces/prisma.binding';

export class AddUserRole {
  static readonly type = '[User] Add User Roles';
  constructor(public userRole: UserRole) {}
}
